import React,{useState,useEffect} from 'react'
import { useNavigate ,  useLocation} from 'react-router-dom'

const Spinner = ({path = "login"}) => {

    const [count,setCount]= useState(3)
    const navigate = useNavigate()
    const Location =useLocation()

    useEffect(()=>{
        const interval = setInterval(()=>{
            setCount((prevValue)=> --prevValue);
        },1000)
        count === 0 && navigate(`/${path}`,{

            state: Location.pathname

        })
        return ()=> clearInterval(interval);
    }, [count,navigate,Location,path]);
  return (
    <>
       <div className="d-flex flex-column justify-content-center align-item-center" style={{height: '100vh'}}>
     
            <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
            <h1 className="Text-center " >Redirecting within {count} second</h1>
            </div>

    
    </>
  )
}

export default Spinner
